export default "__VITE_ASSET__xRGKLxAv__"